/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';
import type { CreateAnnouncementRequest } from '../models/CreateAnnouncementRequest';
import type { CreateAnnouncementResponse } from '../models/CreateAnnouncementResponse';
import type { GetActiveAnnouncementsResponse } from '../models/GetActiveAnnouncementsResponse';
import type { GetAllAnnouncementsResponse } from '../models/GetAllAnnouncementsResponse';
import type { GetAnnouncementByIdResponse } from '../models/GetAnnouncementByIdResponse';
import type { UpdateAnnouncementRequest } from '../models/UpdateAnnouncementRequest';
import type { UpdateAnnouncementResponse } from '../models/UpdateAnnouncementResponse';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
@Injectable({
    providedIn: 'root',
})
export class AnnouncementControllerv2Service {
    constructor(public readonly http: HttpClient) {}
    /**
     * @returns GetAllAnnouncementsResponse
     * @throws ApiError
     */
    public announcementControllerv2GetAllAnnouncements(): Observable<Array<GetAllAnnouncementsResponse>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/v2/announcements',
        });
    }
    /**
     * @param requestBody
     * @returns CreateAnnouncementResponse
     * @throws ApiError
     */
    public announcementControllerv2CreateAnnouncement(
        requestBody: CreateAnnouncementRequest,
    ): Observable<CreateAnnouncementResponse> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/api/v2/announcements',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param count
     * @returns GetActiveAnnouncementsResponse
     * @throws ApiError
     */
    public announcementControllerv2GetActiveAnnouncements(
        count?: number,
    ): Observable<Array<GetActiveAnnouncementsResponse>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/v2/announcements/active',
            query: {
                'count': count,
            },
        });
    }
    /**
     * @param id
     * @returns GetAnnouncementByIdResponse
     * @throws ApiError
     */
    public announcementControllerv2GetAnnouncementById(
        id: number,
    ): Observable<GetAnnouncementByIdResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/v2/announcements/{Id}',
            path: {
                'Id': id,
            },
        });
    }
    /**
     * @param announcementId
     * @param requestBody
     * @returns UpdateAnnouncementResponse
     * @throws ApiError
     */
    public announcementControllerv2UpdateAnnouncement(
        announcementId: number,
        requestBody: UpdateAnnouncementRequest,
    ): Observable<UpdateAnnouncementResponse> {
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/api/v2/announcements/{announcementId}',
            path: {
                'announcementId': announcementId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param announcementId
     * @returns binary
     * @throws ApiError
     */
    public announcementControllerv2DeleteAnnouncement(
        announcementId: number,
    ): Observable<Blob> {
        return __request(OpenAPI, this.http, {
            method: 'DELETE',
            url: '/api/v2/announcements/{announcementId}',
            path: {
                'announcementId': announcementId,
            },
        });
    }
}
